import { Component, OnInit,ViewChild } from "@angular/core";
import { ConfigurationService } from "../../configurationService";
import { ObjectNames } from "../constants/constants";
import { OrdersService } from "../orders/orders.service";
import { OrderFieldsComponent } from "./order-fields/order-fields.component";

@Component({
    selector: "app-orders",
    templateUrl: "./orders.component.html",
    styleUrls: ["./orders.component.scss"],
})
export class OrdersComponent implements OnInit {

    @ViewChild(OrderFieldsComponent) orderfield: OrderFieldsComponent
    index = 0;
    configMenuOrdersItems = [];

    ordersTemplateTypeId: any;
    ordersTemplateConfig: any;
    ordersTemplateJSON: any;
    allOrderTemplates = [];
    ordersSectionTypeId: any;
    ordersFullfillmentTypeId: any;
    ordersBackOrderTypeId: any;

    ordersStatusTypeId: any;
    ordersStatusConfig: any;
    ordersStatusJSON: any;
    allOrderStatus = [];

    ordersSubmoduleTypeId: any;
    ordersSubmoduleConfig: any;
    ordersFullfillmentConfig: any;
    ordersBackOrderConfig: any;
    ordersSubmoduleJSON: any;
    ordersFullfillmentJSON: any;
    ordersBackOrderJSON: any;
    allOrderSubmodule = [];
    allOrderFullfillmentStatus = [];
    allOrderBackOrderStatus = [];

    constructor(
        private service: ConfigurationService,
        private orderConfigService: OrdersService,
    ) { }

    ngOnInit(): void {
        this.getConfigurationTypes();
        this.configMenuOrdersItems = [
            {
                label: "Fullfill",
                icon: "pi pi-plus",
                command: () => { 
                    this.showAddFullfill();
                },
            },
            {
                label: "Return Reason",
                icon: "pi pi-plus",
                command: () => { 
                    this.showAddReason();
                },
            }
        ];
    }

    getConfigurationTypes() {
        this.orderConfigService.getAllTypes().subscribe((types) => {
            this.ordersTemplateTypeId = types.filter(
                (type) =>
                    type.name ==
                    ObjectNames.OrdersConstants.Orders_Template_TypeName
            )[0].id;
            this.ordersStatusTypeId = types.filter(
                (type) =>
                    type.name ==
                    ObjectNames.OrdersConstants.Orders_Status_TypeName
            )[0].id;
            this.ordersSubmoduleTypeId = types.filter(
                (type) =>
                    type.name ==
                    ObjectNames.OrdersConstants.Orders_Submodule_TypeName
            )[0].id;
            this.ordersSectionTypeId = types.filter(
                (type) =>
                    type.name ==
                    ObjectNames.customConstants.Inventory_Section_TypeName
            )[0].id;
            this.ordersFullfillmentTypeId = types.filter(
                (type) =>
                    type.name ==
                    ObjectNames.customConstants.Order_Fullfillment_Object
            )[0].id;
            this.ordersBackOrderTypeId = types.filter(
                (type) =>
                    type.name ==
                    ObjectNames.customConstants.Order_Back_Order_Object
            )[0].id;
            this.loadConfigurations();
        });
    }

    loadConfigurations() {
        this.service.getConfigurationsByModuleName("order").subscribe((configs) => {
            this.ordersTemplateConfig = configs.filter(
                (s) =>
                    s.name ==
                    ObjectNames.OrdersConstants.Orders_Template_Object &&
                    s.typeId == this.ordersTemplateTypeId
            )[0];
            this.ordersTemplateJSON =
                this.ordersTemplateConfig &&
                    this.ordersTemplateConfig.configurationDetails &&
                    this.ordersTemplateConfig.configurationDetails[0]
                        .configJSONValue != ""
                    ? JSON.parse(
                        this.ordersTemplateConfig.configurationDetails[0]
                            .configJSONValue
                    )
                    : [];
            for (let type of this.ordersTemplateJSON) {
                if (type.id !== 0) {
                    this.allOrderTemplates.push(type);
                }
            }

            this.ordersStatusConfig = configs.filter(
                (s) =>
                    s.name ==
                    ObjectNames.OrdersConstants.Orders_Status_Object &&
                    s.typeId == this.ordersStatusTypeId
            )[0];
            // //console.log(
            //     "this.ordersStatusConfig",
            //     ObjectNames.OrdersConstants.Orders_Status_Object
            // );
            // //console.log("this.ordersStatusConfig", this.ordersStatusTypeId);
            // //console.log("this.ordersStatusConfig", this.ordersStatusConfig);
            this.ordersStatusJSON =
                this.ordersStatusConfig?.configurationDetails[0]
                    ?.configJSONValue != ""
                    ? JSON.parse(
                        this.ordersStatusConfig.configurationDetails[0]
                            .configJSONValue
                    )
                    : [];
            for (let status of this.ordersStatusJSON) {
                if (status?.id !== 0) {
                    this.allOrderStatus.push(status);
                }
            }

            this.ordersSubmoduleConfig = configs.filter(
                (s) =>
                    s.name ==
                    ObjectNames.OrdersConstants.Orders_Submodule_Object &&
                    s.typeId == this.ordersSubmoduleTypeId
            )[0];
            this.ordersSubmoduleJSON =
                this.ordersSubmoduleConfig?.configurationDetails[0]
                    ?.configJSONValue != ""
                    ? JSON.parse(
                        this.ordersSubmoduleConfig.configurationDetails[0]
                            .configJSONValue
                    )
                    : [];
            for (let status of this.ordersSubmoduleJSON) {
                if (status?.id !== 0) {
                    this.allOrderSubmodule.push(status);
                }
            }

            this.ordersFullfillmentConfig = configs.filter(
                (s) =>
                    s.name == "Order FulFillment Status" &&
                    s.typeId == this.ordersFullfillmentTypeId
            )[0];

            if (this.ordersFullfillmentConfig?.configurationDetails[0].configJSONValue) {
                this.ordersFullfillmentJSON =
                    this.ordersFullfillmentConfig?.configurationDetails[0]
                        ?.configJSONValue != ""
                        ? JSON.parse(
                            this.ordersFullfillmentConfig?.configurationDetails[0]
                                .configJSONValue
                        )
                        : [];
            }

            if (this.ordersFullfillmentJSON) {
                for (let f of this.ordersFullfillmentJSON) {
                    if (f?.id !== 0) {
                        this.allOrderFullfillmentStatus.push(f);
                    }
                }
            }

            this.ordersBackOrderConfig = configs.filter(
                (s) =>
                    s.name == "Back Order Status" &&
                    s.typeId == this.ordersBackOrderTypeId
            )[0];

            if (this.ordersBackOrderConfig?.configurationDetails[0].configJSONValue) {
                this.ordersBackOrderJSON =
                this.ordersBackOrderConfig?.configurationDetails[0]
                    ?.configJSONValue != ""
                    ? JSON.parse(
                        this.ordersBackOrderConfig?.configurationDetails[0]
                            .configJSONValue
                    )
                    : [];
            }

            if (this.ordersBackOrderJSON) {
                for (let f of this.ordersBackOrderJSON) {
                    if (f?.id !== 0) {
                        this.allOrderBackOrderStatus.push(f);
                    }
                }
            }
        });
    }

    getIndex(event) {
        this.index = event.index;
    }

    showAddFullfill() {
        this.orderConfigService.setFullfill(ObjectNames.BehaviorSubjectVariable);
    }

    showAddReason(){
       this.index =2;
       this.orderfield.showAddReturnReason();
    }
}
